import React from 'react';
import { Modal, Button, Badge } from 'react-bootstrap';
import { Category } from 'store/categoriesSlice';

interface ViewCategoryModalProps {
  show: boolean;
  handleClose: () => void;
  category: Category;
  companyMap: Record<number, string>;
}

const ViewCategoryModal: React.FC<ViewCategoryModalProps> = ({
  show,
  handleClose,
  category,
  companyMap
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="fs-6">Category Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          {/* Basic Information */}
          <div className="row mb-4">
            <div className="col-12">
              <h6 className="text-primary mb-3 border-bottom pb-2">
                Basic Information
              </h6>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Category Name</label>
              <div className="fs-6">{category.name || '-'}</div>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Description</label>
              <div className="fs-6">
                {category.description || 'No description'}
              </div>
            </div>
          </div>

          {/* Additional Information */}
          <div className="row">
            <div className="col-12">
              <h6 className="text-primary mb-3 border-bottom pb-2">
                Additional Information
              </h6>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Company</label>
              <div className="fs-6">
                {companyMap[category.company_id] ||
                  `Company ${category.company_id}`}
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Created Date</label>
              <div className="fs-6">
                {category.created_at
                  ? new Date(category.created_at).toLocaleDateString()
                  : '-'}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0">
        <Button
          variant="phoenix-secondary"
          onClick={handleClose}
          className="px-4"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewCategoryModal;
